// import store from '@/store'

export default function hasPermi (app) {

  app.directive('hasPermi', {
    inserted (el, binding) {
      const { value } = binding
      //console.log(el, binding, '好像没进------------------------------------------')

      // const permissions = ['system:role222:addssss']

      if (value && value instanceof Array && value.length > 0) {

        let pcPerms = JSON.parse(sessionStorage.getItem('pcPerms'))

        //console.log(pcPerms, JSON.parse(sessionStorage.getItem('pcPerms')), '进入了--------------------------')
        const permissions = pcPerms
        const permissionFlag = value


        const harPermission = permissions.some(permission => {
          return (permissionFlag.includes(permission))

        })
        //console.log('真还是假-------------------------')
        if (!harPermission) {
          el.style.display = 'none'
          // el.parentNode && el.parentNode.removeChild(el)
          // 或者：el.style.display = 'none'
        }
      } else {
        throw new Error(`请设置操作权限标签值`)
      }
    }
  })


}